import { RECEIVE_ITEM } from "../actions/items";

export default function items(state = {}, action) {
  switch (action.type) {
    case RECEIVE_ITEM:
      return {
        ...state,
        [action.item.sku]: action.item
      };
    default:
      return state;
  }
}
